export function formatDate(notedate) {
  const date = new Date(notedate);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  return month + '/' + day + '/' + year;
}

export function getRandomInt(min = 1, max = 3) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}



// WEBPACK FOOTER //
// ./src/Helpers/helpers.js